import { timer } from 'rxjs/observable/timer';
import { switchMap, throttleTime, tap, map } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { minutesToMilliseconds } from '../util';

export class TokenRenewer {
  _tokenRenewed$

  constructor(sessionManager, userActivity, clientSecurityApi) {
    this._tokenRenewed$ = userActivity.onUserActive
      .pipe(
        // skipUntil(timer(sessionManager.tokenExpireTime - 60*1000)),
        throttleTime(minutesToMilliseconds(process.env.TOKEN_RENEW_INTERVAL)),
        map(() => sessionManager.token),
        switchMap((token) => clientSecurityApi.renewToken(token)),
        tap(() => console.info("XPSession:", 'Token Renewed'))
      )
  }

  get onTokenRenewed() {
    return this._tokenRenewed$;
  }
}